var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/naming-convention */
import { useState, useCallback } from 'react';
import { requestExport, downloadFromUrl, pollExportUntilComplete } from '../services/exportApi';
// ---------------------------------------------------------------------------
// Tier thresholds
// ---------------------------------------------------------------------------
const SYNC_THRESHOLD = 1000;
const ASYNC_THRESHOLD = 10000;
function getExportTier(totalRows) {
    if (!totalRows || totalRows < SYNC_THRESHOLD)
        return 'sync';
    if (totalRows <= ASYNC_THRESHOLD)
        return 'async';
    return 'background';
}
export function useExport(conversationId) {
    const [isExporting, setIsExporting] = useState(false);
    const [progress, setProgress] = useState(null);
    const [exportTier, setExportTier] = useState(null);
    const [error, setError] = useState(null);
    const triggerExport = useCallback((params) => __awaiter(this, void 0, void 0, function* () {
        if (!conversationId)
            return;
        setIsExporting(true);
        setError(null);
        setProgress(null);
        const { totalRows } = params, exportParams = __rest(params, ["totalRows"]);
        const tier = getExportTier(totalRows);
        setExportTier(tier);
        try {
            const response = yield requestExport(Object.assign({ conversation_id: conversationId }, exportParams));
            const extension = exportParams.format === 'excel' ? 'xlsx' : exportParams.format;
            switch (tier) {
                case 'sync': {
                    // Direct download — response already contains the URL
                    downloadFromUrl(response.download_url, `export.${extension}`);
                    break;
                }
                case 'async': {
                    // Poll with progress until download URL is available
                    const result = yield pollExportUntilComplete(response.download_url, {
                        onProgress: (pct) => setProgress(pct)
                    });
                    if (result.download_url) {
                        downloadFromUrl(result.download_url, `export.${extension}`);
                    }
                    break;
                }
                case 'background': {
                    // Background job — just show a toast, email will be sent by server
                    // eslint-disable-next-line no-console
                    console.log('[useExport] Background export initiated — user will receive email notification.');
                    break;
                }
                default:
                    break;
            }
        }
        catch (err) {
            setError(err instanceof Error ? err : new Error(String(err)));
        }
        finally {
            setIsExporting(false);
            setProgress(null);
        }
    }), [conversationId]);
    return { triggerExport, isExporting, progress, exportTier, error };
}
